import { Checkbox } from '@material-ui/core';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import FlagKeyIdeas from '../flag-key-ideas/FlagKeyIdeas';
import ShowMoreText from '../../../documents/components/ShowMoreText';

const FlagRowInPdfViewer = ({
  flag,
  hiddenSelectionCheckbox,
  selectedItems,
  handleItemSelect,
  citationData,
  isFromPdfViewerPage,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        marginTop: '10px'
      }}
    >
      <div style={{ width: '100%', background: '#000000e0', paddingLeft: 10}}>
        {flag?.keyIdeas?.length > 0 && (
          <FlagKeyIdeas
          keyIdeas={flag?.keyIdeas}
           />
        )}
         <ShowMoreText lines={isFromPdfViewerPage ? 1 : 2} fontSize="small" useIcon={false} isFromPdfViewerPage={isFromPdfViewerPage}>
          {flag?.text}
        </ShowMoreText>
        {!isFromPdfViewerPage && citationData?.author &&
          citationData?.author !== '' &&
          !(citationData?.author).toLowerCase().includes('various') && (
            <span style={{ color: '#888' }}>
              {' (' + citationData?.author}
              {citationData?.year && citationData?.year !== ''
                ? ', ' + citationData?.year
                : ''}
              {')'}
            </span>
          )}
      </div>
      <div style={{ flex: '2' }}>
        {!hiddenSelectionCheckbox && (
          <Checkbox
            hidden={hiddenSelectionCheckbox}
            className="pdf-flags-modal__checkbox"
            checked={selectedItems?.includes(flag)}
            onChange={() => handleItemSelect(flag)}
            icon={<RadioButtonUncheckedIcon fontSize="large" />}
            checkedIcon={<RadioButtonCheckedIcon fontSize="large" />}
          />
        )}
      </div>
    </div>
  );
};

export default FlagRowInPdfViewer;
